import { Controller } from '@hotwired/stimulus';
import {Offcanvas} from "bootstrap/js/index.esm";
import {Calendar} from "@fullcalendar/core";
import deLocale from "@fullcalendar/core/locales/de";
import interactionPlugin from "@fullcalendar/interaction";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import bootstrap5Plugin from '@fullcalendar/bootstrap5';
import listPlugin from "@fullcalendar/list";
import multiMonthPlugin from '@fullcalendar/multimonth'
import $ from "jquery";

export default class extends Controller {
    static targets = [ "textarea", "submitbutton", "editFormContent"]

    initialize()   {
            console.log("initialize erdbeereis")
        this.offcanvasAddEntry =  new Offcanvas('#offcanvasAddEntry')
        this.offcanvasEdit =  new Offcanvas('#offcanvasEdit')
            const $self = this
            const calendarEl = document.getElementById('calendar-holder');
            if (calendarEl) {

                const {eventsUrl, editUrl} = calendarEl.dataset;

                const cal = new Calendar(calendarEl, {
                    initialView: 'dayGridMonth',
                    themeSystem: 'bootstrap5',
                    editable: true,
                    locale: deLocale,
                    buttonText: {
                        today: 'Heute',  // Spanish for "today"
                        month: 'Monat',  // Spanish for "month"
                        week: 'Woche', // Spanish for "week"
                        day: 'Tag',    // Spanish for "day"
                        year: 'Jahr',    // Spanish for "day"
                    },
                    eventSources: [
                        {
                            url: eventsUrl,
                            method: 'POST',
                            extraParams: {
                                filters: JSON.stringify({}) // pass your parameters to the subscriber
                            },
                            failure: () => {
                                // alert('There was an error while fetching FullCalendar!');
                            },
                        },
                    ],
                    headerToolbar: {
                        left: 'prev,next today',
                        center: 'title',
                        right: 'multiMonthYear,dayGridMonth,timeGridWeek',
                    },
                    views: {
                        multiMonthFourMonth: {
                            type: 'multiMonth',
                            duration: {months: 4}
                        }
                    },
                    timeZone: 'UTC',
                    plugins: [interactionPlugin, dayGridPlugin, timeGridPlugin, listPlugin, bootstrap5Plugin, multiMonthPlugin],

                    eventClick: function(info) {

                        info.jsEvent.preventDefault(); // don't let the browser navigate

                        $self.showEdit(info.event.url + '/edit')

                        // change the border color just for fun

                    }
                });

                cal.setOption('locale', 'de');
                cal.render();
            }
        console.log('Connected the calendar controller')


    }
    showAddEntry() {
        this.offcanvasEdit.hide()
        this.offcanvasAddEntry.show()
    }
    async showEdit(url) {
        this.editFormContentTarget.innerHTML = await $.ajax(url);
        this.offcanvasAddEntry.hide()
        this.offcanvasEdit.show()
    }
}
